export const ENDPOINTS = {
    // ROOT: 'https://acciojob-backend-eobnd7jx2q-el.a.run.app',
    ROOT: 'https://acciojob-backend-eobnd7jx2q-el.a.run.app',
};
